import React from 'react';
import { Link } from "react-router";
import Loader from '../loader';
import moment from "moment";
import {t} from "../../../helpers/translator";

export default function nextRacing () {
    if (this.props.data) {
        return (<div className="show-all-h-r">
            {
                this.props.data.map(item =>
                    <div className="racing-h-list-v soon">
                        <ul>
                            <li>
                                <p className={this.props.sportId === "31" ? "horse-icon" : "dog-icon"}><i></i></p>
                            </li>
                            <li>
                                <div><span className={`flag-view-m icon-${item.regionAlias.toLowerCase()}`} /></div>
                            </li>
                            <li>
                                <span>{moment.unix(item.start_ts).calendar()}</span>
                            </li>
                            <li>
                                <p>{item.team1_name}</p>
                            </li>
                            <li>
                                <Link to={`/horseRacing/${this.props.sportId}/${item.regionId}/${item.competitionId}/${item.id}`} className="see-more-racing" activeClassName="active" >{t("See more")}</Link>
                            </li>
                        </ul>
                    </div>)
            }
        </div>
        );
    }
    return <Loader />;
}